import React from "react";
import styles from "./index.module.scss";
// import { useIntl, history, useModel } from 'umi';
import Logo from "../../components/Logo2";

export type NotPermitProps = {};

const NotPermit: React.FC<NotPermitProps> = (props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div>
          <Logo path="/" />
        </div>
        <div style={{ marginTop: 50 }}>
          คุณไม่ได้รับอนุญาติให้เข้าถึงการใช้งานในหน้านี้!
        </div>
        <div style={{ marginTop: 10, textAlign: "center" }}>
          <a
            onClick={() => {
              // history.push('/');
            }}
          >
            กลับไปยังหน้าแรก
          </a>
        </div>
      </div>
    </div>
  );
};
export default NotPermit;
